module.exports = __webpack_public_path__ + "static/media/verified.0cf61a0c.svg";